// Typed API client for the super-admin portal.
//
//   import { api } from '@/api'
//   const page = await api.tenants.list({ q: 'iron', status: 'active' })
//
// Contract types live in ./types (mirrored in admin-portal/API_CONTRACT.md).

import * as auth from './auth'
import * as tenants from './tenants'
import * as audit from './audit'
import * as users from './users'
import * as dashboard from './dashboard'
import * as invites from './invites'

export const api = {
  auth,
  tenants: {
    list: tenants.listTenants,
    get: tenants.getTenant,
    checkSubdomain: tenants.checkSubdomain,
    create: tenants.createTenant,
    update: tenants.updateTenant,
    changeSubdomain: tenants.changeSubdomain,
    changeCustomDomain: tenants.changeCustomDomain,
    customDomainStatus: tenants.customDomainStatus,
    registerCustomDomain: tenants.registerCustomDomain,
    updateAccount: tenants.updateAccount,
    updateAddons: tenants.updateAddons,
    updateAttribution: tenants.updateAttribution,
    setTicketingFee: tenants.setTicketingFee,
    setRegistrationFee: tenants.setRegistrationFee,
    suspend: tenants.suspendTenant,
    reinstate: tenants.reinstateTenant,
    delete: tenants.deleteTenant,
    impersonationLink: tenants.impersonationLink,
    usage: tenants.getUsage,
    sports: {
      catalog: tenants.sportCatalog,
      list: tenants.listSports,
      activate: tenants.activateSport,
      archive: tenants.archiveSport,
      restore: tenants.restoreSport,
    },
    admins: {
      list: tenants.listTenantAdmins,
      add: tenants.addTenantAdmin,
      changeRole: tenants.changeTenantAdminRole,
      setPassword: tenants.setTenantAdminPassword,
      remove: tenants.removeTenantAdmin,
    },
  },
  users: {
    list: users.listUsers,
    get: users.getUser,
    update: users.updateUser,
  },
  audit: {
    list: audit.listAudit,
    logins: audit.listLogins,
    export: audit.auditExport,
    loginsExport: audit.loginsExport,
  },
  dashboard: {
    get: dashboard.getDashboard,
    usageOverview: dashboard.usageOverview,
  },
  invites: {
    listForTenant: invites.listTenantInvites,
    inviteToTenant: invites.inviteToTenant,
    listSuperAdmin: invites.listSuperAdminInvites,
    inviteSuperAdmin: invites.inviteSuperAdmin,
    resendInvite: invites.resendInvite,
    revokeInvite: invites.revokeInvite,
    inviteLink: invites.inviteLink,
  },
}

export { ApiError, isApiError, errorMessage, configureClient } from './client'
export { inactiveAttention, sortAttention, INACTIVE_DAYS } from './dashboard'
export * from './types'
